import React, { useState } from 'react';
import Button from '../shared/Button';
import Textarea from '../shared/Textarea';
import './NewsModal.css';

const NewsModal = ({ onClose, onSubmit, marketQuestion, factors = [] }) => {
  const [newsText, setNewsText] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async () => {
    if (newsText.trim().length < 10) return;

    setIsSubmitting(true);
    await onSubmit(newsText.trim());
    setIsSubmitting(false);
  };

  // Generate contextual hints based on factors
  const getPlaceholder = () => {
    if (factors.length > 0) {
      const factor = factors[0];
      return `e.g., Breaking news about ${factor.label?.toLowerCase() || 'a key factor'}...`;
    }
    return 'e.g., Breaking: Major development affects market outlook...';
  };

  return (
    <div className="news-modal__overlay" onClick={onClose}>
      <div className="news-modal" onClick={e => e.stopPropagation()}>
        <div className="news-modal__header">
          <h2>Introduce News</h2>
          <button className="news-modal__close" onClick={onClose}>&times;</button>
        </div>

        <div className="news-modal__content">
          <div className="news-modal__market">
            <span className="news-modal__market-label">Market Question</span>
            <span className="news-modal__market-text">{marketQuestion}</span>
          </div>

          <Textarea
            label="News Event"
            value={newsText}
            onChange={(e) => setNewsText(e.target.value)}
            placeholder={getPlaceholder()}
            required
            maxLength={500}
            showCounter
            rows={4}
          />

          <p className="news-modal__hint">
            Enter a news headline or event. The system will analyze how it affects
            each factor in the graph and propagate the impact to the market outcome.
          </p>

          {factors.length > 0 && (
            <div className="news-modal__factors">
              <span className="news-modal__factors-label">Factors in this graph:</span>
              <div className="news-modal__factors-list">
                {factors.slice(0, 6).map((factor, i) => (
                  <span key={i} className="news-modal__factor-tag">
                    {factor.label}
                  </span>
                ))}
                {factors.length > 6 && (
                  <span className="news-modal__factor-more">+{factors.length - 6} more</span>
                )}
              </div>
            </div>
          )}

          <div className="news-modal__actions">
            <Button variant="secondary" onClick={onClose}>
              Cancel
            </Button>
            <Button
              onClick={handleSubmit}
              disabled={isSubmitting || newsText.trim().length < 10}
            >
              {isSubmitting ? 'Analyzing...' : 'Propagate'}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewsModal;
